import fleetInventory from '../json/fleet-inventory.json';
import fleetDetails from '../json/fleet-details.json';

// Map tab keys to inventory keys
const TAB_MAP = {
    'sail_boats_tab': 'sail_boats',
    'sail_yachts_tab': 'sail_yachts',
    'motor_yachts_tab': 'motor_yachts',
    'speed_boats_tab': 'speed_boats',
    'ferry_boats_tab': 'ferry_boats'
};

const FleetService = {
    // Get list of boats for a specific tab category from Inventory (for cards)
    getFleetCategory: (tabKey) => {
        const inventoryKey = TAB_MAP[tabKey];
        if (!inventoryKey || !fleetInventory[inventoryKey]) return [];

        return fleetInventory[inventoryKey].map(boat => ({
            ...boat,
            // Ensure guestCount format matches expected prop if needed, or update component
            guestCount: `${boat.guests} Guests`,
            // Normalize image path if needed
            image: boat.image.startsWith('/') ? boat.image : `/${boat.image}`,
            trip: boat.trips // Rename trips -> trip for compatibility
        }));
    },

    // Get full boat details by slug (merging Details JSON + Inventory JSON)
    getFleetBySlug: (slug) => {
        if (!slug) return null;

        // Find in Details JSON
        const detailData = fleetDetails.find(d => d.slug === slug);
        if (!detailData) return null;

        // Find in Inventory JSON to get Gallery & Price
        let inventoryData = null;
        let categoryKey = '';

        for (const [key, boats] of Object.entries(fleetInventory)) {
            const found = boats.find(b => {
                // Try matching by exact name or checking if slug could be derived
                const s = b.name.toLowerCase().replace(/\s+/g, '-');
                return s === slug;
            });

            if (found) {
                inventoryData = found;
                categoryKey = key;
                break;
            }
        }

        // Merge Data
        return {
            ...detailData, // name, about, points, type, etc.
            // Data from Inventory
            price: inventoryData?.price,
            gallery: inventoryData?.gallery?.map(img => img.startsWith('/') ? img : `/${img}`) || [],
            image: inventoryData?.image?.startsWith('/') ? inventoryData.image : `/${inventoryData?.image}`,
            guestCount: detailData.guests ? `${detailData.guests} Guests` : (inventoryData ? `${inventoryData.guests} Guests` : ''),
            trip: detailData.trips || inventoryData?.trips || [],
            category: Object.keys(TAB_MAP).find(key => TAB_MAP[key] === categoryKey) || 'sail_boats_tab' // reverse map
        };
    },
    // Get valid tab keys
    getValidTabKeys: () => Object.keys(TAB_MAP)
};

export default FleetService;
